import CryptoJS from 'crypto-js';

const getItem = (key: any) => {
    const item = localStorage.getItem(key);  
    if (item !== null) {
        const bytes = CryptoJS.AES.decrypt(item, 'sw');
        const value = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return value;
    }
    else
        return null;
};

const setItem = (key: any, value: any) => {
    localStorage.setItem(key, CryptoJS.AES.encrypt(JSON.stringify(value), 'sw').toString());
};

const removeItem = (key: string) => {
    localStorage.removeItem(key);
};

export default {
    getItem,
    setItem,
    removeItem,
};